import React from "react";
import EmptyTasksState from "./EmptyTasksState";
import TasksView from "./TasksView";
import SubscriptionView from "./SubscriptionView";

const MainContent = ({
  showSubscriptionMenu,
  setShowSubscriptionMenu,
  tasks,
  showCompleted,
  subscriptionTier,
  email,
}) => {
  if (showSubscriptionMenu) {
    const tierMap = {
      0: "personal",
      1: "plus",
      2: "pro",
    };
    const currentTierId = tierMap[subscriptionTier] || "personal";

    return (
      <SubscriptionView
        email={email}
        onGoBack={() => setShowSubscriptionMenu(false)}
        currentSubscription={currentTierId}
      />
    );
  }

  if (tasks.length === 0) {
    return <EmptyTasksState showCompleted={showCompleted} />;
  }

  return (
    <TasksView
      subscriptionTier={subscriptionTier}
      onShowSubscriptionMenu={() => setShowSubscriptionMenu(true)}
    />
  );
};

export default MainContent;
